import { render, staticRenderFns } from "./SectionComponent.vue?vue&type=template&id=1e18da4d"
import script from "./SectionComponent.vue?vue&type=script&lang=js"
export * from "./SectionComponent.vue?vue&type=script&lang=js"
import style0 from "./SectionComponent.vue?vue&type=style&index=0&id=1e18da4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports